<template>
    <canvas id="confetti-canvas"></canvas>
</template>
<script>

const confetti = require('canvas-confetti');

export default {

    props:{
        triggerCount:{
            type: Number,
            default: 1,
            required : false,
        }
    },

    data(){
        return {
            canvas: null,
            defaultsConfig: null,
            confettiCount: 0,
        }
    },

    mounted(){

            this.canvas = document.getElementById('confetti-canvas');

            this.defaultsConfig = {
                origin: {y: 0.5},
                gravity: 0.7,
                shapes: ['square'],
                colors: ['#FFC296', '#ACDDF4', '#F5C9D1'],
                startVelocity: 25,
            };

            this.canvas.confetti = this.canvas.confetti || confetti.create(this.canvas, {resize: true});

            this.buildConfetti()
            this.confettiInterval = setInterval(this.buildConfetti, 3000);
    },

    methods:{

        fire(particleRatio, opts) {
            this.canvas.confetti(Object.assign({}, this.defaultsConfig, opts, {
                particleCount: Math.floor(200 * particleRatio)
            }));
        },

        buildConfetti() {
            this.fire(0.25, {
                spread: 26,
            });
            this.fire(0.2, {
                spread: 60,
            });
            this.fire(0.35, {
                spread: 100,
                decay: 0.91,
                scalar: 0.8
            });
            this.fire(0.1, {
                spread: 120,
                decay: 0.92,
                scalar: 1.2
            });
            this.fire(0.1, {
                spread: 120,
            });

            this.confettiCount++;
            if (this.confettiCount >= this.triggerCount) {
                clearInterval(this.confettiInterval);
            }

        }
    }
}
</script>